
export const successMessageContent: string[] = [
    "Twoje hasło zostało zmienione",

]